import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {Observable, ReplaySubject} from "rxjs";
import {first} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ContractInitialBalance} from "../interface/contract-initial-balance";

@Injectable({
  providedIn: 'root'
})
export class ContractInitialBalanceService {

  private readonly contractInitialBalanceListSubject: ReplaySubject<CountedAndPaginated<ContractInitialBalance>> = new ReplaySubject<CountedAndPaginated<ContractInitialBalance>>(1);

  constructor(
      private httpClient: HttpClient,
      private filterService: FilterService,
  ) { }

  public sendForm(formData: object, contractInitialBalanceId?: string): Observable<any> {
    if (contractInitialBalanceId) {
      return this.httpClient.put(`/rest/crm/contract-initial-balance/${contractInitialBalanceId}`, formData)
          .pipe(
              first()
          );
    } else {
      return this.httpClient.post('/rest/crm/contract-initial-balance', formData)
          .pipe(
              first()
          );
    }
  }
  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/contract-initial-balance?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
        .pipe(
            first()
        )
        .subscribe((result: CountedAndPaginated<ContractInitialBalance>) => {
          this.contractInitialBalanceListSubject.next(result);
        });
  }
  public get(contractInitialBalanceId: string): Observable<ContractInitialBalance> {
    return this.httpClient.get(`/rest/crm/contract-initial-balance/${contractInitialBalanceId}`)
        .pipe(first()) as Observable<ContractInitialBalance>;
  }

}
